import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    typeSelect: {
        typeId: 1,
        roomId: 0,
    },
    exhibitionSelect : [],
    openDetail: false,
    create: false,
    roomSubTopic: { id: null },
    audioDetail: {
        id: null,
        title: "",
        script: "",
        imageAltText: "",
        imageUrl: "",
        mapImageUrl: "",
        audioUrl: "",
        invalid: "false",
        seq: 0,
    },
    audioList: [],
    imageFile: null,
    imageMapFile: null,
    audioFile: null,
    previewImage: null,
    previewImageMap: null,
}

const audio = createSlice({
    name: 'common',
    initialState,
    reducers: {
        setTypeSelect(state, action) {
            state.typeSelect = action.payload;
        },
        setCreate(state, action) {
            state.create = action.payload;
        },
        setExhibitionSelect(state, action) {
            state.exhibitionSelect = action.payload;
        },
        setSubTopicList(state, action) {
            state.subTopicList = action.payload;
        },
        emptySubTopicList(state) {
            state.subTopicList = null;
        },
        setOpenModal(state, action) {
            state.openDetail = action.payload;
        },
        setAudioDetail(state, action) {
            state.audioDetail = action.payload;
        },
        setAudioList(state, action) {
            state.audioList = action.payload;
        },
        setRoomSubTopicId(state, action) {
            state.roomSubTopic = action.payload;
        },
        setImageFile(state, action) {
            state.imageFile = action.payload;
        },
        setImageMapFile(state, action) {
            state.imageMapFile = action.payload;
        },
        setAudioFile(state, action) {
            state.audioFile = action.payload;
        },
        setPreviewImage(state, action) {
            state.previewImage = action.payload;
        },
        setPreviewMapImage(state, action) {
            state.previewImageMap = action.payload;
        },
    }
})

export const audioActions = audio.actions;
export default audio;